import * as Search from '../constants/Search';
// import * as Header from '../actions/Header';

const initialState = {
  searchCommunity: null
}


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Search.SEARCH_COMMUNITY_RESULT:
      return Object.assign({}, state, {
        searchCommunity: action.communities
      })
    case Search.SEARCH_COMMUNITY_RESULT_REMOVE:
      return Object.assign({}, state, {
        searchCommunity: null
      })
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/Search.js